"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _mobxReact = require("mobx-react");
var _mobx = require("mobx");
var _lodash = require("lodash");
var _state = require("@seedlang/state");
var _stores = require("@seedlang/stores");
var _utils = require("@seedlang/utils");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
var LIMIT = 10;
var DeckHistoryWrapper = function DeckHistoryWrapper(Component) {
  var _class, _descriptor, _descriptor2, _descriptor3;
  return (0, _mobxReact.observer)((_class = /*#__PURE__*/function (_React$Component) {
    function _class() {
      var _this;
      _classCallCheck(this, _class);
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      _this = _callSuper(this, _class, [].concat(args));
      _initializerDefineProperty(_this, "refreshing", _descriptor, _this);
      _initializerDefineProperty(_this, "loadFailed", _descriptor2, _this);
      _initializerDefineProperty(_this, "loadVersion", _descriptor3, _this);
      _this.loadDecks = function () {
        var requestId = _this.requestId = (_this.requestId || 0) + 1;
        _this.loadFailed = false;
        _stores.UserDeckStore.clearIndexData();
        _stores.UserDeckStore.clearFilter();
        _stores.UserDeckStore.getIndex({
          limit: LIMIT,
          sort: '-user_decks.updated_at',
          filters: {
            'joins:deck|language_id': _state.AppUI.targetLanguageId
          },
          queryStrings: {
            user_id: _state.AppUI.user.id
          },
          failureCallback: function failureCallback() {
            return _this.onLoadFailed(requestId);
          },
          onRequestError: function onRequestError() {
            return _this.onLoadFailed(requestId);
          }
        }, function (response) {
          if (_this.unmounted || requestId !== _this.requestId) return;
          _stores.UserDeckStore.afterGetIndex(response);
          _this.refreshing = false;
          _this.loadVersion += 1;
        });
      };
      _this.onLoadFailed = function (requestId) {
        if (_this.unmounted || requestId !== _this.requestId) return;
        _this.refreshing = false;
        _this.loadFailed = true;
      };
      _this.onRefresh = function () {
        if (_stores.UserDeckStore.hasOutstandingRequests) return;
        _this.refreshing = true;
        _this.loadDecks();
      };
      return _this;
    }
    _inherits(_class, _React$Component);
    return _createClass(_class, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        this.disposeLanguageReaction = (0, _mobx.reaction)(function () {
          return _state.AppUI.targetLanguageId;
        }, this.loadDecks);
        if (this.props.navigation) {
          this.unsubscribeFocus = this.props.navigation.addListener('focus', this.loadDecks);
          if (this.props.navigation.isFocused()) this.loadDecks();
        } else {
          this.loadDecks();
        }
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        var _this$unsubscribeFocu, _this$disposeLanguage;
        this.unmounted = true;
        (_this$unsubscribeFocu = this.unsubscribeFocus) === null || _this$unsubscribeFocu === void 0 || _this$unsubscribeFocu.call(this);
        (_this$disposeLanguage = this.disposeLanguageReaction) === null || _this$disposeLanguage === void 0 || _this$disposeLanguage.call(this);
        _stores.UserDeckStore.clearIndexData();
      }
    }, {
      key: "render",
      value: function render() {
        var rows = _stores.UserDeckStore.indexData.map(function (userDeck) {
          var _deck$concept;
          var deck = userDeck.deck;
          var total = (deck === null || deck === void 0 ? void 0 : deck.cardsCount) || 0;
          var name = [deck === null || deck === void 0 ? void 0 : deck.name, deck === null || deck === void 0 || (_deck$concept = deck.concept) === null || _deck$concept === void 0 ? void 0 : _deck$concept.name, (0, _lodash.startCase)(deck === null || deck === void 0 ? void 0 : deck.deckType)].find(_utils.isPresent) || 'Review';
          return {
            userDeck: userDeck,
            name: name,
            total: total,
            current: userDeck.finished ? total : Math.min(userDeck.progressCurrent + 1, total),
            showProgress: (deck === null || deck === void 0 ? void 0 : deck.deckType) !== 'review'
          };
        });
        return /*#__PURE__*/_react["default"].createElement(Component, _extends({}, this.props, {
          store: _stores.UserDeckStore,
          rows: rows,
          userId: _state.AppUI.user.id,
          loading: _stores.UserDeckStore.hasOutstandingRequests && !_stores.UserDeckStore.initialRequestReceived && !this.refreshing,
          showEmpty: _stores.UserDeckStore.initialRequestReceived && !_stores.UserDeckStore.hasIndexData,
          showPaginator: _stores.UserDeckStore.totalCount > LIMIT || rows.length === LIMIT || _stores.UserDeckStore.page > 1,
          loadFailed: this.loadFailed,
          refreshing: this.refreshing,
          loadVersion: this.loadVersion,
          onRefresh: this.onRefresh,
          onReload: this.loadDecks
        }));
      }
    }]);
  }(_react["default"].Component), _descriptor = _applyDecoratedDescriptor(_class.prototype, "refreshing", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return false;
    }
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "loadFailed", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return false;
    }
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "loadVersion", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return 0;
    }
  }), _class));
};
var _default = exports["default"] = DeckHistoryWrapper;